import { authAxios } from "../config"
import { ApiKey } from "../endpoints";

export const getTechnologiesByCategory = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.GetMasterTechnologies}`,data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}

export const addNewTechnologies = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.AddMasterTechnologies}`, data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}

export const updateTechnologies = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.UpdateMasterTechnologies}`, data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}

export const ChangeTechnologiesStatus = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.ChangemasterTechnologiesStatus}`, data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}